import { render, staticRenderFns } from "./MarqueeText.vue?vue&type=template&id=b0a171ea&scoped=true"
import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"
import style0 from "./MarqueeText.vue?vue&type=style&index=0&id=b0a171ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a171ea",
  null
  
)

export default component.exports